import { Chip, SxProps } from '@mui/material'

interface ChipToggleProps {
    label: string
    selected: boolean
    onClick: () => void
    sx?: SxProps
}

const defaultChipToggleSx = {
    mr: 1,
    mb: 1
}

const ChipToggle = ({ label, selected, onClick, sx }: ChipToggleProps) => {
    const deleteFn = selected ? onClick : undefined
    return (
        <Chip
            variant={selected ? 'filled' : 'outlined'}
            color="primary"
            label={label}
            onClick={onClick}
            sx={{
                ...defaultChipToggleSx,
                ...sx
            }}
            onDelete={deleteFn}
        />
    )
}

export default ChipToggle
